import { resolveSyncSwitch } from './syncSwitch';
import type { ResolvedSyncSettings } from './types';

/**
 * Riga discreta sotto "Assegnata a": avvisa SUL POSTO che la persona scelta non ha
 * un calendario pronto (Google o Microsoft), quindi l'attività non finirà su nessun
 * calendario. Stessa regola di prontezza dello switch di sincronizzazione
 * (`syncSwitch.ts`), così i due punti del drawer non si contraddicono mai.
 *
 * Nasce da Lovati (14-15/09/2026): Antonio assegnava videochiamate a Paola, che non
 * aveva collegato Google; il riquadro "Sincronizzazione non attiva" stava in fondo,
 * nella sezione calendario, e nessuno lo vedeva. Qui l'avviso sta accanto alla scelta.
 *
 * `settings` null = non ancora risolte: nessun avviso, per non gridare al lupo
 * mentre la query è in volo.
 */
export function resolveAssigneeCalendarHint(params: {
  settings: ResolvedSyncSettings | null;
  assigneeName: string | null;
  isSelf: boolean;
}): string | null {
  const { settings, assigneeName, isSelf } = params;
  if (!settings) return null;
  if (resolveSyncSwitch(settings.google, settings.microsoft).visible) return null;
  if (isSelf) {
    return "Non hai Google o Outlook collegato: l'attività sarà nel tuo calendario Flusia ma non arriverà sul tuo calendario esterno. Si collega dal profilo.";
  }
  const who = assigneeName?.trim() || "L'assegnatario";
  return `${who} non ha Google o Outlook collegato: l'attività sarà nel suo calendario Flusia ma non arriverà sul suo calendario esterno.`;
}
